import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import { loadUser } from 'redux-oidc';
import userManager from 'framework/utils/userManager';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import createRootReducer, { registerReducerCreator } from './reducers';
import allSagas, { registerSagaCreator } from './sagas';
import { history } from './history';

// Create Saga middleware
const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = createRootReducer(history);

const store = createStore(
  combineReducers(reducers),
  composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware) as any)
);
loadUser(store, userManager);

// then run the saga
sagaMiddleware.run(function* gen() {
  yield all(allSagas);
});

// Lets keep Redux state on window, ReduxTools are a bit flaky sometimes
window.ReduxStore = store;

const createReducer = registerReducerCreator(store, reducers);
const createSaga = registerSagaCreator(store, sagaMiddleware);

export default store;
export { createReducer, createSaga };
